// material-ui
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { StyledDrawerHeaderProps } from 'types/components';

// ==============================|| DRAWER HEADER - STYLED ||============================== //

const DrawerHeaderStyled = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' })<StyledDrawerHeaderProps>(({ theme }) => ({
  ...theme.mixins.toolbar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingInlineStart: theme.spacing(0),  // Logical: left in LTR, right in RTL
  variants: [
    {
      props: ({ open }) => open,
      style: { justifyContent: 'flex-start', paddingInlineStart: theme.spacing(3) }
    }
  ]
}));

export default DrawerHeaderStyled;
